import { Observable, throwError as observableThrowError } from "rxjs"

import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { catchError, map } from "rxjs/operators"
import "rxjs/Rx"
import { LearningObject } from "../models/learningObject.model"
import { LmApiService } from "./lm-api.service"
import { LocalizationService } from "./localization.service"

@Injectable()
export class FeaturedService {
    constructor(
        private http: HttpClient,
        private lmApi: LmApiService,
        private localizationService: LocalizationService
    ) {}

    public getFeaturedResources(): Observable<any> {
        return this.lmApi
            .getWithCookiesInParams("/api/v2/lm/homepage/resources/")
            .pipe(
                map((response: any) => {
                    return response.objects.map((resource) => {
                        return new LearningObject(resource)
                    })
                }),
                catchError((error) => observableThrowError(error))
            )
    }

    public getFeaturedCollections(): Observable<any> {
        let collectionsURL = "/api/v2/lm/homepage/collections/"
        if (this.localizationService.hasOrganization()) {
            collectionsURL += `${this.localizationService.getOrganizationId()}/`
        }
        return this.lmApi.getWithCookiesInParams(collectionsURL).pipe(
            map((response: any) => {
                return response.objects.map((collection) => {
                    return new LearningObject(collection)
                })
            }),
            catchError((error) => observableThrowError(error))
        )
    }

    public getFeaturedSeries(): Observable<any> {
        return this.lmApi
            .getWithCookiesInParams("/api/v2/lm/homepage/series/")
            .pipe(
                map((response: any) => {
                    return response.objects
                }),
                catchError((error) => observableThrowError(error))
            )
    }
}
